;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: ["services", "initial"],
  data: function data() {
    return {
      serviceIds: []
    };
  },

  methods: {
    deselect: function deselect(value) {
      var index = this.serviceIds.indexOf(parseInt(value));
      if (index > -1) {
        this.serviceIds.splice(index, 1);
      }
    }
  },
  mounted: function mounted() {
    this.serviceIds = this.initial;
    var vm = this;
    setTimeout(function () {
      $("#services").multiSelect({
        selectableHeader: "<input type='text' class='form-control search-input' autocomplete='off' placeholder='Available'>",
        selectionHeader: "<input type='text' class='form-control search-input' autocomplete='off' placeholder='Selected'>",
        afterInit: function afterInit(ms) {
          var that = this,
              $selectableSearch = that.$selectableUl.prev(),
              $selectionSearch = that.$selectionUl.prev(),
              selectableSearchString = "#" + that.$container.attr("id") + " .ms-elem-selectable:not(.ms-selected)",
              selectionSearchString = "#" + that.$container.attr("id") + " .ms-elem-selection.ms-selected";

          that.qs1 = $selectableSearch.quicksearch(selectableSearchString).on("keydown", function (e) {
            if (e.which === 40) {
              that.$selectableUl.focus();
              return false;
            }
          });

          that.qs2 = $selectionSearch.quicksearch(selectionSearchString).on("keydown", function (e) {
            if (e.which == 40) {
              that.$selectionUl.focus();
              return false;
            }
          });
        },
        afterSelect: function afterSelect() {
          this.qs1.cache();
          this.qs2.cache();
        },
        afterDeselect: function afterDeselect(value) {
          this.qs1.cache();
          this.qs2.cache();
          vm.deselect(value);
        }
      });
    }, 1000);
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"services"}},[_vm._v("Services")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.serviceIds),expression:"serviceIds"}],staticStyle:{"display":"none"},attrs:{"id":"services","multiple":"multiple","name":"role[service_ids][]"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.serviceIds=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.services),function(service,index){return _c('option',{key:index,domProps:{"value":service.id}},[_vm._v("\n      "+_vm._s(service.name)+"\n    ")])}))])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ab765794", __vue__options__)
  } else {
    hotAPI.reload("data-v-ab765794", __vue__options__)
  }
})()}